import { Features } from '@platform/ics-front-core';
import rkkLogo from './rkk-logo.svg';

const logoStyle = { width: '131px', height: '32px' };

const features: Features = {
    loginWithoutRegister: false,
    customLogo: false,
    headerLogo: {
        isEnabled: true,
        locales: {
            ru: {
                image: rkkLogo,
                alt: 'РКК',
                style: logoStyle,
            },
            en: {
                image: rkkLogo,
                alt: 'RRC',
                style: logoStyle,
            },
        },
    },
    notificationIcon: true,
    phoneNumber: true,
    esiaLogin: true,
    showCreateRequestButton: true,
    showRequestsCount: true,
    loginDialogAlert: false,
    yaMetrika: false,
    modularNavigation: true,
    footerLogo: false,
    samlAuth: false,
    showCampaignPeriod: true,
    allUsersRedirectPath: false,
    isWithRegistrationPage: false,
    isWithoutHelpIconAuthPage: true,
    isWithoutStartPageLogo: true,
};

export default features;
